import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { Outlet, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Toaster } from "sonner";

import Authorize from "../components/Authorize";
import axiosInstance from '../utils/axiosInstance.js';
import packageInfo from '../../package.json';

// Tenant Assets
import { applyTenantConfig, getMasterTenant } from "../whitelabels/theme.js";

// Popup Form usage
import UserCreatePopupForm from '../components/popupPage/UserCreatePopUp.js';
import UserInfoPopUp from '../components/popupPage/UserInfoPopUp.js';
import TenantBackupsPopupForm  from "../components/popupPage/TenantBackupPopUp.js";

function DashboardPageLayout() {

  // Popup Form usage
  const [openPopup, setOpenPopup] = useState(null);
  const closePopup = () => setOpenPopup(null);

  const [backendStatus, setBackendStatus] = useState(true);

  const [footerString, setFooterString] = useState("");
  const [userInfo, setUserInfo] = useState(null);  
  const navigate = useNavigate();
  const tenantPath = sessionStorage.getItem("tenantPath") || "ripcord";
  const token = sessionStorage.getItem("jwtToken");
  const decoded = jwtDecode(token);

  // Apply the theme and get logo, title based on the tenantPath
  const [config] = useState(() => applyTenantConfig(tenantPath));

  const fetchUserInfo = async (userEmail) => {
    try {
      const response = await axiosInstance.get(`/users/info/${userEmail}`);
      return response.data;
    } catch (err) {
      setBackendStatus(false);
      console.error("Failed to fetch user info", err);
      return null;
    }
  };
  
  const handleViewUserInfo = async () => {
    const userEmail = decoded?.email;
    if (!userEmail) return;
  
    const userInfo = await fetchUserInfo(userEmail);
    if (userInfo) {
      setUserInfo(userInfo);
      setOpenPopup("userInfo")
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('tenantPath');

    // When logout, always route it back to the loginf for the master Tenant.
    const masterTenant = getMasterTenant(tenantPath);
    navigate(`/login?tenant=${masterTenant}`, {replace: true,});
  };

  useEffect(() => {
    let string = `Ripcord Platform: v${packageInfo.version}`;
    if (!backendStatus)
    {
      string += ` [backend offline]`
    }
    setFooterString(string)
  }, [backendStatus]);

  return (
  <div>
        <div className="header-bar">
        <img src={config.companyLogo} alt="Comapny Logo" className="header-icon"></img>
        <div className="header-text">{config.dashboardTitle}</div>
      </div>
      <div>
        {openPopup === "tenantBackup" && (
          <TenantBackupsPopupForm
            onClose={closePopup}
            userData={decoded}
          />
        )}
        {openPopup === "userCreate" && (
          <UserCreatePopupForm
            onClose={closePopup}
            sessionRole={decoded.role}
            sessionTenantName={decoded.tenantName}
          />
        )}
        {openPopup === "userInfo" && (
          <UserInfoPopUp
            onClose={closePopup}
            infoData={userInfo}
          />
        )}
      </div>
      <div className="user-welcome-container">
        <div className="user-welcome-text">
          <FontAwesomeIcon icon={faUser} />
          <b>{`  Welcome, ${decoded?.email}!`}</b>{" "}
          {` You have logged in as "${decoded?.role}", ${config.welcomeMessage}`}
        </div>
        <div className="tenant-actions-container">
          <Authorize roles={["admin", "subAdmin"]}>
            <button className="submit-btn" onClick={() => setOpenPopup("tenantBackup")}>
              Backup Management
            </button>
          </Authorize>
          <button className="submit-btn" onClick={handleViewUserInfo}>
            List User Info
          </button>
          <Authorize roles={["god"]}>
            <button className="submit-btn" onClick={() => setOpenPopup("userCreate")}>
              Create Tenant and Admin
            </button>
          </Authorize>
          <Authorize roles={["admin"]}>
            <button className="submit-btn" onClick={() => setOpenPopup("userCreate")}>
              Create User
            </button>
          </Authorize>
          <button className="submit-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
        {/* Child page rendered here */}
        <Outlet />

      <div className="footer">
        {footerString}
      </div>
      <Toaster position="bottom-center" />

  </div>
  )
}

export default DashboardPageLayout;